import { RootState } from '../../../../../../../../init-store';
import { Area } from '../types';
import { CONTAINER_PADDING, DebugMenuContainerDrawer } from './debug-menu-container-drawer';
import { STATS_DRAWER_HEIGHT, STATS_DRAWER_WIDTH, StatsDrawer } from './stats-drawer';

type DebugMenuDrawers = {
    containerDrawer: DebugMenuContainerDrawer;
    statsDrawer: StatsDrawer;
};

let DRAWERS: DebugMenuDrawers | null = null;

function initDrawers(): DebugMenuDrawers {
    const containerArea: Area = {
        x: 0,
        y: 0,
        width: STATS_DRAWER_WIDTH + CONTAINER_PADDING * 2,
        height: STATS_DRAWER_HEIGHT + CONTAINER_PADDING * 2,
    };
    const containerDrawer = new DebugMenuContainerDrawer(containerArea);

    const statsDrawerArea: Area = {
        x: containerArea.x + CONTAINER_PADDING,
        y: containerArea.y + CONTAINER_PADDING,
        width: containerArea.width - CONTAINER_PADDING * 2,
        height: containerArea.height - CONTAINER_PADDING * 2,
    };
    const statsDrawer = new StatsDrawer(statsDrawerArea);

    return {
        containerDrawer,
        statsDrawer,
    };
}

export function drawDebugMenu(ctx: CanvasRenderingContext2D, state: RootState) {
    if (!DRAWERS) {
        DRAWERS = initDrawers();
    }

    DRAWERS.containerDrawer.draw(ctx);
    DRAWERS.statsDrawer.draw(ctx, state);
}
